/**
 * Labstep
 *
 * @module components/ShareLink/Action/Create
 * @desc Create a ShareLink
 */

import { LayoutLoadingContent as LoadingContent } from 'labstep-web/components/Layout/LoadingContent';
import { ShareLinkInfo } from 'labstep-web/components/ShareLink/Info';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { ShareLink } from 'labstep-web/models/share-link.model';
import React from 'react';
import type {
  ICreateShareLinkProps,
  IShareLinkActionCreateProps,
} from './types';

export class CreateShareLink extends React.Component<ICreateShareLinkProps> {
  componentDidMount() {
    const { create, entity, parentEntity } = this.props;

    if (!entity) {
      create({
        [`${parentEntity.entityName}_id`]: parentEntity.id,
      });
    }
  }

  render() {
    const { entity, status, parentEntity, children, ...rest } =
      this.props;
    const shareLink = entity;

    const viewComponent = children ? (
      children({ shareLink })
    ) : (
      <ShareLinkInfo
        shareLink={shareLink}
        parentEntity={parentEntity}
        {...rest}
      />
    );

    if (entity) {
      return viewComponent;
    }

    return (
      <LoadingContent
        defaultFetching
        status={status}
        loader="placeholder"
      >
        {viewComponent}
      </LoadingContent>
    );
  }
}

export const ShareLinkActionCreate: React.FC<
  IShareLinkActionCreateProps
> = ({ parentEntity, ...rest }) => (
  <EntityCreateContainer
    entityName={ShareLink.entityName}
    uuid={`share_link_${parentEntity.entityName}_${parentEntity.id}`}
    children={(containerProps) => (
      <CreateShareLink
        parentEntity={parentEntity}
        {...containerProps}
        {...rest}
        entity={containerProps.entity as ShareLink}
      />
    )}
  />
);
